import logo from "./logo.svg";
import "./App.css";
import "./assets/css/style.css";
import "./assets/css/responsive.css";
import { Routes, Route } from "react-router-dom";
import MainWrapper from "./Pages/MainWrapper";
import Header from "./Components/Header";
import Home from "./Pages/Home";
import Biography from "./Pages/Biography";
import Footer from "./Components/Footer";
import Awards from "./Pages/Awards";
import ThoughtLeadership from "./Pages/ThoughtLeadership";
import MediaGallery from "./Pages/MediaGallery";
import Events from "./Pages/Events";
import Contact from "./Pages/Contact";
import ScrollToTop from "./Components/ScrollToTop";

function App() {
  return (
    <div className="App">
      <Header />

       <ScrollToTop />
      <Routes basename="/">
        {/* <Route path="/" element={<MainWrapper />} /> */}
        <Route path="/" element={<Home />} />
        <Route path="/biography" element={<Biography />} />
        <Route path="/awards" element={<Awards />} />
        <Route path="/thought-leadership" element={<ThoughtLeadership />} />
        <Route path="/media-gallery" element={<MediaGallery />} />
        <Route path="/events" element={<Events />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
